<template>
  <div v-html="renderedHtml"></div>
</template>

<script>
import localForage from "localforage"
import { marked } from 'marked';
export default {
  props: ['content'],
  data() {
    return {
      renderedHtml: '',
    };
  },
  async created() {
    this.renderedHtml = await this.renderMarkdown(this.content);
  },
  watch: {
    // 侦听'content' prop的变化
    async content(newValue) {
      // 当'content'变化时，重新处理内容
      this.renderedHtml = await this.renderMarkdown(this.content);
    }
  },
  methods: {
    async renderMarkdown(content) {
      const renderedHtml = marked(content);
      return this.htmlRenderImages(renderedHtml);
    },
    async htmlRenderImages(renderedHtml) {
      // 创建一个虚拟的DOM容器，用于解析和操作HTML字符串
      const parser = new DOMParser();
      const doc = parser.parseFromString(renderedHtml, 'text/html');

      // 查询所有的<img>标签
      const images = doc.querySelectorAll('img');
      for (const img of images) {
        // 假设每个<img>的src属性原先都设置为在localForage中的键名
        const key = img.getAttribute('src');
        console.log("happen->key", key)
        const imageData = await localForage.getItem(key);
        console.log(key, imageData)
        if (imageData) {
          // 替换src属性为base64数据
          img.setAttribute('src', imageData);
        }
      }

      // 将更新后的HTML转换回字符串
      const serializer = new XMLSerializer();
      const updatedHtml = serializer.serializeToString(doc);
      return updatedHtml
    },
  },
}
</script>
